var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { staticClass: "inputs", attrs: { xs: "12" } },
                [
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.ComputedFriendlyID,
                      label: _vm.$ct("friendly-id"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.JournalID,
                      label: _vm.$ct("journal"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.InvoiceNR,
                      label: _vm.$ct("invoice-nr"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.InvoiceDate.toLocaleDateString(),
                      label: _vm.$ct("invoice-date"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.VatPeriod,
                      "calculate-decimals": 0,
                      decimals: 0,
                      label: _vm.$ct("vat-period"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.AccountingPeriod,
                      "calculate-decimals": 0,
                      decimals: 0,
                      label: _vm.$ct("accounting-period"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: { value: _vm.value.Total, label: _vm.$ct("total") },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.DiscountPercantage,
                      label: _vm.$ct("discount"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.ExpirationDate.toLocaleDateString(),
                      label: _vm.$ct("expiration-date"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: { label: _vm.$ct("type"), value: _vm.purchaseType },
                  }),
                  _c("app-info-input", {
                    attrs: {
                      value: _vm.value.Communication,
                      label: _vm.$ct("communication"),
                    },
                  }),
                  _c("app-info-input", {
                    attrs: { value: _vm.ogm, label: _vm.$ct("ogm") },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-aws-files", {
        attrs: { files: _vm.value.Documents, "hide-if-no-module": "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }